import {
    Authorize,
    Commit_Order_List,
    Daily_Fulfilled_Order,
    Daily_Order, Daily_SKU_Info,
    Filter_ASN, Get_Api_Key_For_Auth, GetApiKey, MonthLy_Fulfilled_Order, MonthLy_Order, Order_Fulfillment_Metrics,
    Today_Fulfillment_Info,
    Today_Order_Increase,
    Total_Sku_Inv
} from "../../config";
import api from "../../api/api";
import {noop} from "lodash";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";

export const DashboardActionType = {
    RESET_DASHBOARD:'RESET_DASHBOARD',
    DAILY_FULFILLED_ORDER:'DAILY_FULFILLED_ORDER',
    DAILY_ORDER:'DAILY_ORDER',
    DAILY_SKU_INFO:'DAILY_SKU_INFO',
    TODAY_ORDER_INCREASE:'TODAY_ORDER_INCREASE',
    TODAY_FULFILLMENT_INFO:'TODAY_FULFILLMENT_INFO',
    MONTHLY_ORDER_INFO:'MONTHLY_ORDER_INFO',
    MONTHLY_FULFILLED_ORDER_INFO:'MONTHLY_FULFILLED_ORDER_INFO',
    TOTAL_SKU_INV:'TOTAL_SKU_INV',
    ORDER_FULFILLMENT_METRICS:'ORDER_FULFILLMENT_METRICS',
    COMMIT_ORDER_LIST:'COMMIT_ORDER_LIST',
    RESET_COMMIT_ORDER_LIST:'RESET_COMMIT_ORDER_LIST'
}

export const resetDashboardInfo = () => async dispatch => {

    try {

            dispatch({
                type:DashboardActionType.RESET_DASHBOARD,
                payload:""})
    } catch (e) {
        console.log(e.message)

    }
}

export const getDailyFulfilledOrder = (data,onError = noop) => async dispatch => {
    try {

        const url = `${Daily_Fulfilled_Order}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.DAILY_FULFILLED_ORDER,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}

export const getApiKeyForAuth = (data,onSuccess,onError = noop) => async dispatch => {
    try {
        const url = `${process.env.REACT_APP_TEMU_API_URL}${Get_Api_Key_For_Auth}?id=${data?.ownerId}`
        // const url = `${process.env.REACT_APP_TEMU_API_URL}${Get_Api_Key_For_Auth}?id=${403732164230}`
        const response = await api.get(url, ).then(res=>res)
        if(response.data.errorCode === 0){
            onSuccess(response.data.result)
        }else {
            onError("DashboardPage.Get API info failed, Please Contact Darwynn Administrator")
        }
    } catch (e) {
        console.log(e.message)
        onError("DashboardPage.Get API info failed, Please Contact Darwynn Administrator")
    }
}

export const createAuthorization = (data,onSuccess,onError = noop) => async dispatch => {
    try {
        const url = `${process.env.REACT_APP_TEMU_API_URL}${Authorize}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response.data.errorCode === 0){
            // onSuccess(response.data.result)
            onSuccess("DashboardPage.Authorization Successful")
        }else {
            onError("DashboardPage.Authorization failed, Please Contact Darwynn Administrator")
        }
    } catch (e) {
        console.log(e.message)
        onError("DashboardPage.Authorization failed, Please Contact Darwynn Administrator")
    }
}

export const getDailyOrder = (data,onError = noop) => async dispatch => {
    try {

        const url = `${Daily_Order}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.DAILY_ORDER,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}

export const getDailySKUInfo = (data,onError = noop) => async dispatch => {
    try {

        const url = `${Daily_SKU_Info}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.DAILY_SKU_INFO,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}





export const getTodayOrderIncrease = (data,onError = noop) => async dispatch => {
    try {
        const url = `${Today_Order_Increase}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.TODAY_ORDER_INCREASE,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}

export const getTodayFulfillment = (data,onError = noop) => async dispatch => {
    try {

        const url = `${Today_Fulfillment_Info}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.TODAY_FULFILLMENT_INFO,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}


export const getMonthlyOrderInfo = (data,onError = noop) => async dispatch => {
    try {
        const url = `${MonthLy_Order}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.MONTHLY_ORDER_INFO,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}

export const getMonthlyFulfilledOrderInfo = (data,onError = noop) => async dispatch => {
    try {
        const url = `${MonthLy_Fulfilled_Order}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.MONTHLY_FULFILLED_ORDER_INFO,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}


export const getTotalSkuInv = (data,onError = noop) => async dispatch => {
    try {
        const url = `${Total_Sku_Inv}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.TOTAL_SKU_INV,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}



export const getOrderFulfillmentMetrics = (data,onError = noop) => async dispatch => {
    try {
        const url = `${Order_Fulfillment_Metrics}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.ORDER_FULFILLMENT_METRICS,
                payload:response.data
            })
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        console.log(e.message)
        onError(e.message)
    }
}

export const getCommitOrderList = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.DashBoardDataList)) return null;
        const url = `${Commit_Order_List}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:DashboardActionType.COMMIT_ORDER_LIST,
                payload:response.data
            })
            onSuccess(response?.data?.data)
        }else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError()
        console.log(e.message)
        onError(e.message)
    }
}

export const resetCommitOrderList = (onSuccess = noop,onError = noop) => async dispatch => {
    try {
        dispatch({
            type:DashboardActionType.RESET_COMMIT_ORDER_LIST,
            payload:null
        })
    } catch (e) {
        onError()
        console.log(e.message)
    }
}





